export const DeviceContext = {
  NEW: 'NEW',
  CONNECTED: 'CONNECTED',
  DEACTIVATED: 'DEACTIVATED',
};
